var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSplash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 221,
    height: 211,
    viewBox: "0 0 221 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221 105.5C221 94.8022 199.133 87.5928 195.876 77.8252C192.619 67.8251 206.112 48.9877 199.831 40.6155C193.549 32.0107 171.682 39.2201 163.075 32.941C154.7 26.8944 154.467 3.63826 144.464 0.382409C134.694 -2.87345 121.201 15.7314 110.267 15.7314C99.5663 15.7314 85.8411 -2.87345 76.0705 0.382409C66.0674 3.63826 65.8347 26.6618 57.46 32.941C48.8526 39.2201 26.9853 32.0107 20.7042 40.6155C14.6558 48.9877 27.9158 67.8251 24.6589 77.8252C21.8674 87.5928 0 94.8022 0 105.5C0 116.198 21.8674 123.407 25.1242 133.175C28.3811 143.175 14.8884 162.012 21.1695 170.385C27.4505 178.989 49.3179 171.78 57.9253 178.059C66.3 184.106 66.5326 207.362 76.5358 210.618C86.3063 213.873 99.799 195.269 110.733 195.269C121.434 195.269 135.159 213.873 144.929 210.618C154.933 207.362 155.165 184.338 163.54 178.059C172.147 171.78 194.015 178.989 200.296 170.385C206.344 162.012 193.084 143.175 196.341 133.175C199.133 123.407 221 116.198 221 105.5Z",
    fill: "#90DF9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147 78L97.5 127.5L75 105",
    stroke: "#F4F4F9",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSplash);
export default __webpack_public_path__ + "static/media/check-splash.6abdf5134169b741f2922ac861e0dc0e.svg";
export { ForwardRef as ReactComponent };